export function formatNumberWithCommas(num: number) {
  return num.toLocaleString();
}
